import { render, staticRenderFns } from "./task-ff.vue?vue&type=template&id=b660f512&"
import script from "./task-ff.vue?vue&type=script&lang=js&"
export * from "./task-ff.vue?vue&type=script&lang=js&"
import style0 from "./task-ff.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports